import { NgModule } from "@angular/core";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { UnauthorizedErrorHandlerService } from "./unauthorized-error-handler.service";
import { LoginWraperService } from "../login.wraper.service";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";
import { DialogsService } from "../dialogs.service";

@NgModule({
    imports: [
        MatDialogModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: UnauthorizedErrorHandlerService,
            multi: true
        },
        //MatDialog,
        //DialogsService,
        //LoginWraperService
    ]
})
export class UnauthorizedErrorHandlerModule {

}